import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { deleteServiceRole, getAllServiceRole, getServiceRoleById, pagingServiceRole, saveOrUpdateServiceRole } from "app/services/ServiceRole";
import { ServiceRole } from "app/common/Model/ServiceRole";

export default class ServiceRoleStore {
    listAllServiceRole = [];
    searchServiceRole = new SearchObject();
    pageServiceRole = null;
    selectedServiceRole = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteServiceRole = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllServiceRole = () => {
        getAllServiceRole().then(({ data }) => {
            this.listAllServiceRole = data;
        })
    }
    
    pagingServiceRole = () => {
        pagingServiceRole(this.searchServiceRole).then(({ data }) => {
            this.pageServiceRole = data;
        })
    }

    handleChangeFormSearch = (searchServiceRole) => {
        this.searchServiceRole = checkSearchObject(this.searchServiceRole, searchServiceRole);
        this.pagingServiceRole();
    }

    handleOpenFormCreateOrEdit = (serviceRoleId) => {
        if (Boolean(serviceRoleId)) {
            getServiceRoleById(serviceRoleId).then(({ data }) => {
                this.selectedServiceRole = data;
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedServiceRole = new ServiceRole();
            this.openFormCreateOrEdit = true;
        }
    }

    saveServiceRole = async (serviceRole, { setSubmitting }) => {
        return await saveOrUpdateServiceRole(serviceRole).then(() => {
            this.selectedServiceRole = null;
            toast.success("Lưu loại dịch vụ thành công!");
            this.pagingServiceRole();
            this.handleClosePopup();
        })
            .catch((error) => toast.error("Lưu loại dịch vụ thất bại!"))
            .finally(() => setSubmitting(false));
    }

    handleDeleteServiceRole = (serviceRole) => {
        this.selectedServiceRole = { id: serviceRole?.id };
        this.openConfirmDeleteServiceRole = true;
    }

    handleConfirmDeleteServiceRole = () => deleteServiceRole(this.selectedServiceRole?.id)
        .then(() => {
            if (this.searchServiceRole?.pageIndex > 1 && this.pageServiceRole?.content?.length === 1) {
                this.searchServiceRole.pageIndex -= 1;
            }
            toast.success("Xóa loại dịch vụ thành công!");
            this.pagingServiceRole();
            this.recentlyUpdated = true;
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa loại dịch vụ thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteServiceRole = false;
    }

    resetStore = () => {
        this.searchServiceRole = new SearchObject();
        this.pageServiceRole = null;
        this.selectedServiceRole = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteServiceRole = false;
    }
}